module.exports = __webpack_public_path__ + "img/lbsq.29d2e8a5.png";